var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const Two = (_a) => {
    var { color = '#000000', width = 22, height = 22, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", Object.assign({ width: 25, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M10.243 14.709a56.437 56.437 0 0 0 2.219-1.928 9.176 9.176 0 0 0 1.377-1.625c.368-.56.551-1.111.551-1.652 0-.493-.116-.88-.348-1.16-.232-.28-.59-.421-1.073-.421s-.855.164-1.116.493c-.261.319-.396.759-.406 1.32H9.475c.039-1.16.382-2.04 1.03-2.64.657-.599 1.488-.899 2.493-.899 1.102 0 1.948.295 2.538.885.59.58.884 1.349.884 2.305a4.18 4.18 0 0 1-.609 2.161 8.727 8.727 0 0 1-1.392 1.798 45.889 45.889 0 0 1-2.044 1.827h4.277v1.682H9.49v-1.508l.754-.638Z", fill: color }),
        React.createElement("rect", { x: 1.5, y: 1, width: 22, height: 22, rx: 11, stroke: color, strokeWidth: 2 })));
};
export default Two;
